module.exports = __webpack_public_path__ + "static/media/student2.0e759dab.png";